import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { AppFunctions } from "../../constants/app-functions";

import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";

@Component({
    selector: 'select-dialog',
    templateUrl: 'select-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatSelectModule]
})
  export class SelectDialogComponent {

    selectedOption: any;

    constructor(
      public dialogRef: MatDialogRef<SelectDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {options: [], label: string},
      
    ) {}
  
    onNoClick(): void {
      //this.dialogRef.
      this.dialogRef.close();
    }

    moneyFormat(s: string): string{
      return AppFunctions.numberWithSpaces(s);
    }
  
    dateFormat(dt: string): string{
  
      return AppFunctions.stringToDatetime(dt);
    }
  }